import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { task, timeout } from 'ember-concurrency';
import { debug } from '@ember/debug';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div\n  id={{this.mapElementId}}\n  {{did-insert this.setupMap}}\n  {{did-update this.didUpdateAttrs @item}}\n  class=\'here-map\'\n></div>");

var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
const DEBOUNCE_MS = 500;
function guid() {
  return 'here-map-' + Math.random().toString(36).substr(2, 9);
}
function hasCoordinates(lat, lng) {
  return [lat, lng].every(value => value !== null && value !== undefined && value !== '');
}
let HereMapComponent = (_dec = task(function* () {
  const item = yield this.item;
  if (!item) return;
  const lat = item.location_position_lat;
  const lng = item.location_position_lng;
  if (hasCoordinates(lat, lng)) {
    yield this.initMapLatLong.perform();
  } else {
    yield this.initMapLocationTask.perform();
  }
  this.showMap = true;
}).restartable(), _dec2 = task(function* () {
  if (!this.mapElement) return;
  yield this.applicationController.loadHereMapTask.perform();
  const platform = this.herePlatform;
  if (!platform) return;
  const geocoder = platform.getSearchService();
  const address = this.item?.location_address_text;
  if (!address) return;
  const geocodingParameters = {
    q: address,
    limit: 1
  };
  try {
    const result = yield new Promise((resolve, reject) => {
      geocoder.geocode(geocodingParameters, resolve, reject);
    });
    const locations = result?.items ?? [];
    if (locations.length > 0) {
      yield this.addLocationsToMap.perform(locations);
    }
  } catch (error) {
    debug(`Geocoding failed: ${error}`);
  }
}), _dec3 = task(function* (locations) {
  if (!this.mapElement) return;
  yield this.applicationController.loadHereMapTask.perform();
  if (this.isDestroying || this.isDestroyed) return;
  const platform = this.herePlatform;
  if (!platform) return;

  // Dispose vecchia mappa prima di crearne una nuova
  if (this.map) {
    try {
      this.map.dispose();
    } catch {
      /* già disposta */
    }
    this.map = null;
  }
  const defaultLayers = platform.createDefaultLayers();
  const map = new H.Map(this.mapElement, defaultLayers.vector.normal.map, {
    zoom: 13
  });
  this.map = map;
  const group = new H.map.Group();
  locations.forEach(({
    position,
    address
  }) => {
    const marker = new H.map.Marker(position);
    marker.label = address.label;
    group.addObject(marker);
  });
  group.addEventListener('tap', evt => {
    map.setCenter(evt.target.getGeometry());
  });
  map.addObject(group);
  const boundingBox = group.getBoundingBox();
  if (boundingBox?.getCenter()) {
    map.setCenter(boundingBox.getCenter());
  }
  new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
  const ui = H.ui.UI.createDefault(map, defaultLayers);
  ui.getControl('mapsettings')?.setVisibility(false);
}), _dec4 = task(function* () {
  if (!this.mapElement) return;
  if (!this.herePlatform) {
    yield this.applicationController.loadHereMapTask.perform();
  }
  yield timeout(DEBOUNCE_MS);
  if (this.isDestroying || this.isDestroyed) return;
  const platform = this.herePlatform;
  if (!platform) return;
  const lat = this.item.location_position_lat;
  const lng = this.item.location_position_lng;
  const coords = {
    lat,
    lng
  };

  // Dispose vecchia mappa prima di crearne una nuova
  if (this.map) {
    try {
      this.map.dispose();
    } catch {
      /* già disposta */
    }
    this.map = null;
  }
  const defaultLayers = platform.createDefaultLayers();
  const map = new H.Map(this.mapElement, defaultLayers.vector.normal.map, {
    zoom: 13
  });
  this.map = map;
  new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
  const ui = H.ui.UI.createDefault(map, defaultLayers);
  ui.getControl('mapsettings')?.setVisibility(false);
  if (hasCoordinates(lat, lng)) {
    yield timeout(DEBOUNCE_MS);
    if (this.isDestroying || this.isDestroyed) return;
    const marker = new H.map.Marker(coords);
    map.addObject(marker);
    map.setCenter(coords);
  }
}), _class = class HereMapComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "map", _descriptor, this);
    _initializerDefineProperty(this, "showMap", _descriptor2, this);
    this.mapElementId = guid();
    _initializerDefineProperty(this, "creaMapTask", _descriptor3, this);
    _initializerDefineProperty(this, "initMapLocationTask", _descriptor4, this);
    _initializerDefineProperty(this, "addLocationsToMap", _descriptor5, this);
    _initializerDefineProperty(this, "initMapLatLong", _descriptor6, this);
  }
  get applicationController() {
    return this.args.applicationController;
  }
  get item() {
    return this.args.item;
  }
  get herePlatform() {
    return this.applicationController?.Hereplatform;
  }
  get mapElement() {
    return document.getElementById(this.mapElementId);
  }
  willDestroy() {
    super.willDestroy();
    if (this.map) {
      this.map.dispose();
      this.map = null;
    }
  }
  setupMap() {
    this.creaMapTask.perform();
  }
  didUpdateAttrs() {
    this.creaMapTask.perform();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "map", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showMap", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setupMap", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "didUpdateAttrs", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didUpdateAttrs"), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "creaMapTask", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "initMapLocationTask", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "addLocationsToMap", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "initMapLatLong", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
setComponentTemplate(TEMPLATE, HereMapComponent);

export { HereMapComponent as default };
//# sourceMappingURL=here-map.js.map
